const assembleiasRoutes = [
  {
    path: '/assembleias',
    name: 'assembleias',
    component: () => import('@/views/assembleia/admin/AssembleiaList.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Assembleias', active: true },
      ],
    },
  },
  {
    path: '/assembleias/votacao',
    name: 'assembleias-votacao-list',
    component: () => import('@/views/assembleia/votacao/VotacaoList.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Assembleias', url: '/' },
        { title: 'Votação', active: true },
      ],
    },
  },
  {
    path: '/assembleias/votacao/:id',
    name: 'assembleias-votacao-view',
    component: () => import('@/views/assembleia/votacao/VotacaoView.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Assembleias', url: '/' },
        { title: 'Votação', url: '/assembleias/votacao' },
        { title: 'Visualizar', active: true },
      ],
    },
  },
  {
    path: '/assembleias/atas',
    name: 'assembleias-atas',
    component: () => import('@/views/assembleia/ata/AtaList.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Assembleias', url: '/' },
        { title: 'Atas', active: true },
      ],
    },
  },
  {
    path: '/assembleias/edit',
    name: 'assembleias-new',
    component: () => import('@/views/assembleia/admin/AssembleiaEdit.vue'),
    meta: {
      parent: 'assembleias',
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Assembleias', url: '/assembleias' },
        { title: 'Cadastrar', active: true },
      ],
    },
  },
  {
    path: '/assembleias/edit/:id',
    name: 'assembleias-edit',
    component: () => import('@/views/assembleia/admin/AssembleiaEdit.vue'),
    meta: {
      parent: 'assembleias',
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Assembleias', url: '/assembleias' },
        { title: 'Editar', active: true },
      ],
    },
  },
]

export default assembleiasRoutes
